query ExportGiveawayCsv($giveawayId: ID!) {
  csv: StreamToolsExportGiveawayCsv(giveawayId: $giveawayId)
}
